// import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Vue from 'vue'
// import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import customThemes from './themes.js'
import Ripple from 'vuetify/lib/directives/ripple';
import langs from '../language/languages'

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
});

//import es from 'vuetify/lib/locale/es'
// import es from 'vuetify/es5/locale/es'

// Vue.component('my-component', {
//   methods: {
//     changeLocale () {
//       this.$vuetify.lang.current = 'es'
//     },
//   },
// })

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },

    themes: {
      light: {
        ...customThemes.light
      },
      dark: {
        ...customThemes.dark
      },
    },
  },
  lang: {
    locales: langs,
    current: langs[window.navigator.language] ? window.navigator.language : 'es'
  }
});
